import userFA from './fa/fa.json'

const UserMessages = {
  fa: { ...userFA },
}

export default UserMessages
